<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-data-table
          :headers="monthItemDataTableHeaders"
          :items="monthItemList"
          :search="searchMonthItem"
          class="elevation-1"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          item-key="Number"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('quotation_item_return_tool_bar_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchMonthItem"
                append-icon="mdi-magnify"
                :label="$t('quotation_item_new_install_search')"
                single-line
                hide-details
                clearable
              ></v-text-field>
              <v-btn
                color="primary"
                class="mb-2 ml-8"
                :disabled="isAllTextFieldDisabled"
                @click="openMonthItem"
              >
                {{ $t('quotation_item_new_install_new_item_btn') }}
              </v-btn>
              <v-dialog
                v-model="isShowEditMonthItemDialog"
                v-if="isShowEditMonthItemDialog"
                persistent
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ $t('quotation_item_return_month') }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <ValidationObserver ref="dialogMonthItem">
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <month-item-autocomplete
                              :fatherEditedItem="editedMonthItem"
                              :itemName="'quotation_item_number'"
                              @setEditedMonthItem="setEditedMonthItem"
                              v-if="editedMonthItemIndex === -1"
                              @keyupEnter="focusNextInput"
                              refName="monthItemAutocomplete"
                            />
                            <ValidationProvider
                              :name="$t('quotation_item_number')"
                              rules="required"
                              v-slot="{ errors }"
                              v-else
                            >
                              <v-text-field
                                v-model="editedMonthItem.Number"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_number') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_name')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Name"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_name') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_unit')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Unit"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_unit') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field
                              :label="$t('quotation_item_month_number')"
                              v-model="editedMonthItem.MonthNumber"
                              readonly
                              @click="isShowSelectMonthNumberDialogBtn"
                              clearable
                            ></v-text-field>
                            <v-dialog v-model="isShowSelectMonthNumberDialog" persistent fullscreen>
                              <v-card>
                                <v-card-text class="pa-5">
                                  <v-data-table
                                    :headers="selectMonthNumberTableHeaders"
                                    :items="selectMonthList"
                                    class="elevation-1"
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_data')"
                                    :no-results-text="$t('common_no_results')"
                                    :footer-props="{
                                      'items-per-page-options': [30, 50, 100],
                                      'items-per-page-text': $t('item_rows_per_page'),
                                    }"
                                    :header-props="headerProps"
                                  >
                                    <template v-slot:top>
                                      <v-toolbar flat>
                                        <v-toolbar-title>選擇月租序號</v-toolbar-title>
                                      </v-toolbar>
                                    </template>
                                    <template v-slot:[`item.Choose`]="{ item }">
                                      <v-btn color="primary" @click="chooseMonthNumber(item)">
                                        選擇
                                      </v-btn>
                                    </template>
                                  </v-data-table>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    color="red darken-1"
                                    text
                                    @click="closeShowSelectMonthNumberDialogBtn"
                                  >
                                    {{ $t('common_close') }}
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('month_quantity')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Quantity"
                                :error-messages="errors[0]"
                                suffix="個月"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('month_quantity') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                            xl="3"
                            v-if="editedMonthItem.PayType === payType.Quantity"
                          >
                            <ValidationProvider
                              name="新增計量數量"
                              :rules="{ required: true, regex: /^\d+\.?\d*$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.AddPayQuantity"
                                :error-messages="errors[0]"
                                suffix="個"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  新增計量數量
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                            xl="3"
                            v-if="editedMonthItem.PayType === payType.Quantity"
                          >
                            <ValidationProvider
                              name="原始計量數量"
                              :rules="{ required: true, regex: /^\d+\.?\d*$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.PayQuantity"
                                :error-messages="errors[0]"
                                suffix="個"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                                :disabled="editedMonthItem.MonthNumber"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  原始計量數量
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Price"
                                :error-messages="errors[0]"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                            xl="3"
                            v-if="!editedMonthItem.MonthNumber"
                          >
                            <ValidationProvider
                              name="折扣"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Discount"
                                :error-messages="errors[0]"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  折扣
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="折扣後單價"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.DiscountPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  折扣後單價
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_total_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.TotalPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_total_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_rent_warranty_period')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.RentWarrantyPeriod"
                                :error-messages="errors[0]"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_rent_warranty_period') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="收款方式"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayType"
                                :items="allPayType"
                                item-text="Name"
                                item-value="Type"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_data')"
                                ref="payTypeAutocomplete"
                                :error-messages="errors[0]"
                                @change="onPayTypeChange"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  收款方式
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <ValidationProvider
                              name="計費時間"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayTimeRangeType"
                                :items="payTimeRangeTypeList"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  計費時間
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            v-if="editedMonthItem.PayType === payType.Quantity"
                            cols="12"
                            sm="6"
                            md="3"
                            lg="3"
                            xl="3"
                          >
                            <ValidationProvider
                              name="計量方式"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayQuantityType"
                                :items="allPayQuantityType"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  計量方式
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-textarea
                              outlined
                              :label="$t('quotation_item_remark')"
                              v-model="editedMonthItem.Remark"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </ValidationObserver>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeEditedMonthItem">
                      {{ $t('common_cancel') }}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="saveEditedMonthItem">
                      {{ $t('common_save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <delete-dialog
                :isAllTextFieldDisable="false"
                :isLoadingSaveBtn="false"
                :isShowDeleteDialog="isShowDeleteMonthItemDialog"
                :deleteMessage="'quotation_item_delete_item_dialog_title'"
                @closeDelete="closeDeleteMonthItem"
                @confirmDelete="confirmDeleteMonthItem"
              />
              <v-btn
                color="primary"
                class="mb-2 ml-8"
                :disabled="isAllTextFieldDisabled"
                @click="openBomMonthItem"
              >
                新增月租BOM
              </v-btn>
              <v-dialog
                v-model="isShowEditBomMonthItemDialog"
                v-if="isShowEditBomMonthItemDialog"
                persistent
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ $t('quotation_item_new_month') }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <ValidationObserver ref="dialogMonthItem">
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_name')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.Name"
                                :items="monthBomList"
                                item-text="Name"
                                item-value="Id"
                                return-object
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_results')"
                                :disabled="editedMonthItemIndex !== -1"
                                :error-messages="errors[0]"
                                :loading="isLoading"
                                @click="getAllMonthBoms"
                                @change="setMonthBomItem"
                                ref="bomNameAutocomplete"
                                @keyup.enter="setBomName"
                              >
                                <template v-slot:item="data">
                                  <template>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        {{ data.item.Name }}
                                      </v-list-item-title>
                                      <v-list-item-subtitle>
                                        {{ data.item.Describe }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </template>
                                </template>
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_name') }}
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('month_quantity')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Quantity"
                                :error-messages="errors[0]"
                                suffix="個月"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('month_quantity') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                            xl="3"
                            v-if="editedMonthItem.PayType === payType.Quantity"
                          >
                            <ValidationProvider
                              name="新增計量數量"
                              :rules="{ required: true, regex: /^\d+\.?\d*$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.AddPayQuantity"
                                :error-messages="errors[0]"
                                suffix="個"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  新增計量數量
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_unit')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Unit"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_unit') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Price"
                                :error-messages="errors[0]"
                                @change="changeMonthTotal"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="折扣"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Discount"
                                :error-messages="errors[0]"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  折扣
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="折扣後單價"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.DiscountPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  折扣後單價
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_total_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.TotalPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_total_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_rent_warranty_period')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.RentWarrantyPeriod"
                                :error-messages="errors[0]"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_rent_warranty_period') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="收款方式"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayType"
                                :items="allPayType"
                                item-text="Name"
                                item-value="Type"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_data')"
                                @keyup.enter="setPayTypeAutocomplete"
                                @change="onPayTypeChange"
                                ref="payTypeAutocomplete"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  收款方式
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <ValidationProvider
                              name="計費時間"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayTimeRangeType"
                                :items="payTimeRangeTypeList"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  計費時間
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            v-if="editedMonthItem.PayType === payType.Quantity"
                            cols="12"
                            sm="6"
                            md="3"
                            lg="3"
                            xl="3"
                          >
                            <ValidationProvider
                              name="計量方式"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayQuantityType"
                                :items="allPayQuantityType"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  計量方式
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-textarea
                              outlined
                              :label="$t('quotation_item_remark')"
                              v-model="editedMonthItem.Remark"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </ValidationObserver>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeEditedBomMonthItem">
                      {{ $t('common_cancel') }}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="saveEditedBomMonthItem">
                      {{ $t('common_save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.PayType`]="{ item }">
            {{ turnPayType(item.PayType) }}
          </template>
          <template v-slot:[`item.PayTimeRangeType`]="{ item }">
            {{ turnPayTimeRangeType(item.PayTimeRangeType) }}
          </template>
          <template v-slot:[`item.PayQuantityType`]="{ item }">
            {{ turnPayQuantityTypeName(item.PayQuantityType) }}
          </template>
          <template v-slot:[`item.Edit`]="{ item }">
            <v-btn
              icon
              @click="isShowEditMonthItemDialogBtn(item)"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="isShowDeleteMonthItemDialogBtn(item)"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.Move`]="{ item, index }">
            <v-btn
              icon
              @click="upMonthItem(item)"
              v-if="index !== 0"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon>
                mdi-arrow-up-drop-circle-outline
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="downMonthItem(item)"
              v-if="index !== monthItemList.length - 1"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon>
                mdi-arrow-down-drop-circle-outline
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import DeleteDialog from '@/components/DeleteDialog.vue'
import MonthItemAutocomplete from '@/components/MonthItemAutocomplete.vue'
import { HttpMonth, HttpMonthBom } from '@/js/http-Manager'
import { PayType } from '@/js/PayType'
import { PayTimeRangeType } from '@/js/PayTimeRangeType'
import { PayQuantityType } from '@/js/PayQuantityType'
extend('regex', regex)

export default {
  components: {
    DeleteDialog,
    MonthItemAutocomplete
  },
  name: 'ReturnMonthSetting',
  data: () => ({
    payQuantityType: PayQuantityType,
    payType: PayType,
    searchMonthItem: '',
    editedMonthItemIndex: -1,
    isShowEditMonthItemDialog: false,
    isShowDeleteMonthItemDialog: false,
    editedMonthItem: {
      Number: '',
      Name: '',
      RentQuantity: 1,
      AddPayQuantity: 1,
      PayQuantity: 0,
      Quantity: 1,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0,
      MonthNumber: '',
      PayType: 1,
      PayTimeRangeType: 1,
      PayQuantityType: 1
    },
    defaultMonthItem: {
      Number: '',
      Name: '',
      RentQuantity: 1,
      AddPayQuantity: 1,
      PayQuantity: 0,
      Quantity: 1,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0,
      MonthNumber: '',
      PayType: 1,
      PayTimeRangeType: 1,
      PayQuantityType: 1
    },

    regexPrice: /^[0-9]+$/,
    regexQuantity: /^[0-9]+$/,
    regexDecimal: /^\d+\.?\d*$/,
    isShowSelectMonthNumberDialog: false,
    selectMonthList: [],
    isShowEditBomMonthItemDialog: false,
    payTimeRangeTypeList: []
  }),
  async mounted () {
    await this.getAllMonthBoms()
    await this.getAllPayTimeRangeType()
  },
  computed: {
    monthItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('month_quantity'), align: 'end', value: 'Quantity' },
        { text: '新增計量數量', align: 'end', value: 'AddPayQuantity' },
        { text: '原始計量數量', align: 'end', value: 'PayQuantity' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'RentQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        {
          text: this.$t('quotation_item_total_price'),
          align: 'end',
          value: 'TotalPrice'
        },
        {
          text: this.$t('quotation_item_month_number'),
          align: 'end',
          value: 'MonthNumber'
        },
        {
          text: this.$t('quotation_item_rent_warranty_period'),
          align: 'end',
          value: 'RentWarrantyPeriod'
        },
        { text: '收費方式', align: 'center', value: 'PayType' },
        { text: '計費時間', align: 'center', value: 'PayTimeRangeType' },
        { text: '計量方式', align: 'center', value: 'PayQuantityType' },
        { text: this.$t('transfer_order_license_plate'), align: 'start', value: 'LicensePlate' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },
    selectMonthNumberTableHeaders () {
      return [
        {
          text: this.$t('quotation_item_month_number'),
          align: 'start',
          value: 'Number'
        },
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber'
        },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        {
          text: this.$t('quotation_full_name'),
          align: 'start',
          value: 'CustomerFullName'
        },
        { text: this.$t('item_name'), align: 'start', value: 'ItemName' },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        { text: '選擇', value: 'Choose', sortable: false }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    onPayTypeChange () {
      this.editedMonthItem.PayQuantityType = this.payQuantityType.Determined
    },
    turnPayQuantityTypeName (val) {
      return PayQuantityType.PayQuantityTypeName(val)
    },
    async getAllPayTimeRangeType () {
      let response = await HttpMonth.GetPayTimeRangeTypes()
      this.payTimeRangeTypeList = response.status === 200 ? response.data.Data : []
    },
    turnPayTimeRangeType (val) {
      return PayTimeRangeType.PayTimeRangeTypeName(val)
    },
    turnPayType (val) {
      return PayType.PayTypeName(val)
    },
    async getAllMonthBoms () {
      let response = await HttpMonthBom.GetAllMonthBoms()
      this.isLoading = true
      this.monthBomList = response.status === 200 ? response.data.Data : []
      this.isLoading = false
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    downMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.monthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllMonth', temp)
    },
    upMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.monthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllMonth', temp)
    },
    changeMonthTotal () {
      if (
        this.regexQuantity.test(this.editedMonthItem.RentQuantity) &&
        this.regexDecimal.test(this.editedMonthItem.Price) &&
        this.regexQuantity.test(this.editedMonthItem.Quantity) &&
        this.regexDecimal.test(this.editedMonthItem.AddPayQuantity) &&
        this.regexDecimal.test(this.editedMonthItem.PayQuantity) &&
        this.regexDecimal.test(this.editedMonthItem.Discount) &&
        this.regexDecimal.test(this.editedMonthItem.DiscountPrice)
      ) {
        this.editedMonthItem.DiscountPrice =
          this.editedMonthItem.Price - this.editedMonthItem.Discount
        const quantityMultiplier =
          this.editedMonthItem.PayType === this.payType.Quantity
            ? Math.max(
              0,
              this.editedMonthItem.AddPayQuantity * 1 + this.editedMonthItem.PayQuantity * 1
            )
            : 1
        this.editedMonthItem.TotalPrice =
          this.editedMonthItem.RentQuantity *
          this.editedMonthItem.DiscountPrice *
          this.editedMonthItem.Quantity *
          quantityMultiplier *
          1
      }
    },
    setEditedMonthItem (val) {
      this.editedMonthItem.Id = val.Id
      this.editedMonthItem.Number = val.Number
      this.editedMonthItem.Name = val.Name
      this.editedMonthItem.Unit = val.Unit
      this.editedMonthItem.Price = val.Price
      this.editedMonthItem.IsMonthItem = val.IsMonthItem
      this.editedMonthItem.IsDelete = val.IsDelete
      this.editedMonthItem.StoreNo = val.StoreNo
      this.editedMonthItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedMonthItem.Remark = val.Remark
      this.changeMonthTotal()
      this.editedMonthItem = JSON.parse(JSON.stringify(this.editedMonthItem))
    },
    closeEditedMonthItem () {
      this.isShowEditMonthItemDialog = false
      this.editedMonthItem = JSON.parse(JSON.stringify(this.defaultMonthItem))
      this.editedMonthItemIndex = -1
    },
    openMonthItem () {
      this.editedMonthItem.RentQuantity = this.carQuantity
      this.isShowEditMonthItemDialog = true
    },

    isShowEditMonthItemDialogBtn (item) {
      this.editedMonthItemIndex = this.monthItemList.indexOf(item)
      this.editedMonthItem = JSON.parse(JSON.stringify(item))
      this.isShowEditMonthItemDialog = true
    },
    async saveEditedMonthItem () {
      const isValid = await this.$refs.dialogMonthItem.validate()
      if (isValid) {
        let isExist = this.monthItemList.findIndex((x) => x.Id === this.editedMonthItem.Id) !== -1
        if (!isExist || this.editedMonthItemIndex !== -1) {
          this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
          this.$emit('setMonthItem', this.editedMonthItem)
          this.closeEditedMonthItem()
        } else {
          alert('已重複品項')
        }
      }
    },
    isShowDeleteMonthItemDialogBtn (item) {
      this.editedMonthItemIndex = this.monthItemList.indexOf(item)
      this.isShowDeleteMonthItemDialog = true
    },
    closeDeleteMonthItem () {
      this.editedMonthItemIndex = -1
      this.isShowDeleteMonthItemDialog = false
    },
    confirmDeleteMonthItem () {
      this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
      this.$emit('deleteMonthItem')
      this.closeDeleteMonthItem()
    },
    openBomMonthItem () {
      this.editedMonthItem.RentQuantity = this.carQuantity
      this.isShowEditBomMonthItemDialog = true
    },
    setMonthBomItem () {
      this.editedMonthItem.Quantity = this.editedMonthItem.Name.Quantity * 1
      this.editedMonthItem.RentQuantity = this.carQuantity
      this.editedMonthItem.TotalQuantity =
        this.editedMonthItem.Quantity * this.editedMonthItem.Name.RentQuantity * 1
      const quantityMultiplier =
        this.editedMonthItem.PayType === this.payType.Quantity
          ? Math.max(
            0,
            this.editedMonthItem.Name.PayQuantity * 1 +
                this.editedMonthItem.Name.AddPayQuantity * 1
          )
          : 1
      this.editedMonthItem.TotalPrice =
        this.editedMonthItem.TotalQuantity *
        this.editedMonthItem.Name.Price *
        quantityMultiplier *
        1
      this.editedMonthItem.Id = this.editedMonthItem.Name.Id
      this.editedMonthItem.Price = this.editedMonthItem.Name.Price
      this.editedMonthItem.Number = this.editedMonthItem.Name.Number
      this.editedMonthItem.Unit = this.editedMonthItem.Name.Unit
      this.editedMonthItem.Remark = this.editedMonthItem.Name.Describe
      this.editedMonthItem.MonthBomItems = this.editedMonthItem.Name.MonthBomItems
      this.changeMonthTotal()
    },
    async saveEditedBomMonthItem () {
      const isValid = await this.$refs.dialogMonthItem.validate()
      if (isValid) {
        this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
        if (this.editedMonthItem.Name.Name) {
          this.editedMonthItem.Name = this.editedMonthItem.Name.Name
        }
        this.editedMonthItem.MonthBomItems.forEach((element, index) => {
          let isExist = this.monthItemList.findIndex((x) => x.Id === element.Id) !== -1
          if (!isExist) {
            element.Quantity = this.editedMonthItem.Quantity * 1
            element.AddPayQuantity = this.editedMonthItem.AddPayQuantity * 1
            element.PayQuantity = this.editedMonthItem.PayQuantity * 1
            element.RentQuantity = this.editedMonthItem.RentQuantity * 1
            element.TotalQuantity = element.Quantity * element.RentQuantity
            element.RentWarrantyPeriod = this.editedMonthItem.RentWarrantyPeriod
            element.PayType = this.editedMonthItem.PayType
            element.PayTimeRangeType = this.editedMonthItem.PayTimeRangeType
            element.PayQuantityType = this.editedMonthItem.PayQuantityType
            const quantityMultiplier =
              element.PayType === this.payType.Quantity
                ? Math.max(0, element.PayQuantity + element.AddPayQuantity)
                : 1
            if (index === 0) {
              element.Discount = this.editedMonthItem.Discount
              element.DiscountPrice = element.Price - element.Discount
              element.TotalPrice =
                element.DiscountPrice * element.TotalQuantity * quantityMultiplier
            } else {
              element.Discount = 0
              element.DiscountPrice = element.Price
              element.TotalPrice = element.Price * element.TotalQuantity * quantityMultiplier
            }
            this.$emit('setMonthItem', element)
          }
        })
        this.closeEditedBomMonthItem()
      }
    },
    closeEditedBomMonthItem () {
      this.isShowEditBomMonthItemDialog = false
      this.$nextTick(() => {
        this.editedMonthItem = JSON.parse(JSON.stringify(this.defaultMonthItem))
        this.editedMonthItemIndex = -1
      })
    },
    async isShowSelectMonthNumberDialogBtn () {
      await this.getStopMonthList()
      this.isShowSelectMonthNumberDialog = true
    },
    async getStopMonthList () {
      let response = await HttpMonth.GetStopMonthList({
        customerId: this.repairCustomerId,
        monthItemId: this.editedMonthItem.Id
      })
      this.selectMonthList = response.status === 200 ? response.data.Data : []
    },
    closeShowSelectMonthNumberDialogBtn () {
      this.isShowSelectMonthNumberDialog = false
      this.selectMonthList = []
    },
    chooseMonthNumber (item) {
      this.editedMonthItem.MonthNumber = item.Number
      this.editedMonthItem.Quantity = item.MonthQuantity
      this.editedMonthItem.Price = item.OriginalCurrency
      this.editedMonthItem.DiscountPrice = item.OriginalCurrency
      this.editedMonthItem.TotalPrice = item.OriginalCurrency * item.MonthQuantity
      this.editedMonthItem.RentWarrantyPeriod = item.RentWarrantyPeriod
      this.editedMonthItem = JSON.parse(JSON.stringify(this.editedMonthItem))
      this.closeShowSelectMonthNumberDialogBtn()
    }
  },
  props: [
    'isAllTextFieldDisabled',
    'monthItemList',
    'carQuantity',
    'allPayType',
    'allPayQuantityType',
    'repairCustomerId'
  ]
}
</script>
